__turbopack_context__.v({
  "abstractButton": "abstractButton-module-scss-module__opEH9a__abstractButton",
});
